import { Component, DestroyRef, OnInit, signal } from '@angular/core';
import { ModalComponentInterface, ModalInterface } from 'shared/components/modal';
import { UserAuthService } from 'features/user/services/user-auth.service';
import { Idle } from '@ng-idle/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { switchMap, tap } from 'rxjs/operators';
import { AuthUserConfig } from 'features/user/config/config.module';

type InactiveModalComponentData = {
  data: {
    idle: Idle
  }
}

@Component({
  selector: 'app-inactive-modal',
  standalone: true,
  imports: [],
  templateUrl: './inactive-modal.component.html',
})
export class InactiveModalComponent implements ModalInterface, OnInit {
  data: InactiveModalComponentData;
  parentModal: ModalComponentInterface;
  countdownMessage = signal(`You will time out in ${ this.config.user?.auth?.inactiveModalTimoutSeconds ?? 5 } seconds!`);
  title = 'You Have Been Idle!'

  constructor(
    private authService: UserAuthService,
    private destroyRef: DestroyRef,
    private config: AuthUserConfig,
  ) {
  }

  ngOnInit() {
    this.data.data.idle.onTimeoutWarning
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((countdown) => {
        this.countdownMessage.set('You will time out in ' + countdown + ' seconds!');
      });

    this.data.data.idle.onIdleEnd
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.data.data.idle.watch();
      });

    this.data.data.idle.onTimeout
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        tap(() => this.countdownMessage.set('Timed out! Logging out...')),
        switchMap(() => this.authService.logout()),
        tap(() => this.parentModal.close())
      )
      .subscribe();
  }

  dismiss = {
    label: 'Logout',
    action: (modal: ModalComponentInterface) => {
      this.authService.logout()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(() => {
          modal.close();
        });
    }
  }
  confirm = {
    label: 'Stay',
    action: (modal: ModalComponentInterface) => {
      modal.close();
    }
  }
}
